import { BoolFilter, MultiSelectSimpleFilter } from "@dash/filters";

import { DeliveryMethod } from "@megaron/fulfillment-contracts";
import { OrderDisplayFinancialStatus, OrderDisplayFulfillmentStatus } from "@megaron/shopify";

export type OrdersFilterValues = {
  fulfillmentStatus?: string[];
  financialStatus?: string[];
  deliveryMethod?: string[];
  isCancelled?: boolean;
};

type Props = {
  values: OrdersFilterValues;
  onChange: (patch: Partial<OrdersFilterValues>) => void;
  className?: string;
};

const fulfillmentLabels: Record<string, string> = {
  [OrderDisplayFulfillmentStatus.Fulfilled]: "Zrealizowane",
  [OrderDisplayFulfillmentStatus.PartiallyFulfilled]: "Częściowo zrealizowane",
  [OrderDisplayFulfillmentStatus.Unfulfilled]: "Niezrealizowane",
  [OrderDisplayFulfillmentStatus.InProgress]: "W trakcie",
  [OrderDisplayFulfillmentStatus.OnHold]: "Wstrzymane",
  [OrderDisplayFulfillmentStatus.Restocked]: "Zwrócone do magazynu",
};

const financialLabels: Record<string, string> = {
  [OrderDisplayFinancialStatus.Paid]: "Opłacone",
  [OrderDisplayFinancialStatus.PartiallyPaid]: "Częściowo opłacone",
  [OrderDisplayFinancialStatus.Pending]: "Oczekujące",
  [OrderDisplayFinancialStatus.Authorized]: "Autoryzowane",
  [OrderDisplayFinancialStatus.Refunded]: "Zwrócone",
  [OrderDisplayFinancialStatus.PartiallyRefunded]: "Częściowo zwrócone",
  [OrderDisplayFinancialStatus.Voided]: "Unieważnione",
  [OrderDisplayFinancialStatus.Expired]: "Wygasłe",
};

const deliveryLabels: Record<DeliveryMethod, string> = {
  inPostLocker: "Paczkomat InPost",
  inPostCourier: "Kurier InPost",
  shipping: "Wysyłka",
  palletDelivery: "Dostawa paletowa",
  other: "Inne",
};

const fulfillmentValues = Object.keys(fulfillmentLabels);
const financialValues = Object.keys(financialLabels);
const deliveryValues = Object.keys(deliveryLabels) as DeliveryMethod[];

export const fulfillmentOptions = fulfillmentValues.map((v) => ({ label: fulfillmentLabels[v], value: v }));
export const financialOptions = financialValues.map((v) => ({ label: financialLabels[v], value: v }));
export const deliveryMethodOptions = deliveryValues.map((v) => ({ label: deliveryLabels[v], value: v }));

export const nonPalletDeliveryValues: string[] = deliveryValues.filter((v) => v !== "palletDelivery");

export const OrdersFilters: React.FC<Props> = ({ values, onChange, className }) => {
  return (
    <div className={className} css={{ display: "flex", gap: "0.5rem", flexWrap: "wrap", alignItems: "center" }}>
      <MultiSelectSimpleFilter
        label="Realizacja"
        values={values.fulfillmentStatus ?? []}
        options={fulfillmentOptions}
        onChange={(v) => onChange({ fulfillmentStatus: v.length ? v : undefined })}
      />
      <MultiSelectSimpleFilter
        label="Płatność"
        values={values.financialStatus ?? []}
        options={financialOptions}
        onChange={(v) => onChange({ financialStatus: v.length ? v : undefined })}
      />
      <MultiSelectSimpleFilter
        label="Dostawa"
        values={values.deliveryMethod ?? []}
        options={deliveryMethodOptions}
        onChange={(v) => onChange({ deliveryMethod: v.length ? v : undefined })}
      />
      <BoolFilter
        label="Anulowane"
        value={values.isCancelled}
        onChange={(v) => onChange({ isCancelled: v })}
        falseLabel="Nie"
        trueLabel="Tak"
      />
    </div>
  );
};
